<script setup>
import { computed } from 'vue';

const props = defineProps({
  percent: { type: Number, default: 0 },
  status: { type: String, required: true },
  typeLabel: { type: String, required: true },
});

const statusClass = computed(() =>
  props.percent >= 100
    ? 'bg-emerald-100 text-emerald-700'
    : 'bg-lais-primary-50 text-lais-primary'
);
</script>

<template>
  <div class="flex flex-wrap items-center gap-2" data-test="party-status-chips">
    <span
      class="rounded-full px-2 py-1 text-[11px] font-semibold uppercase"
      :class="statusClass"
      data-test="party-status-chip"
    >
      {{ status }}
    </span>
    <span
      class="rounded-full bg-lais-bg-soft px-2 py-1 text-[11px] font-semibold uppercase text-lais-text-muted"
      data-test="party-type-chip"
    >
      {{ typeLabel }}
    </span>
  </div>
</template>
